package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.example.mystybag.appCore.logic.pages.AddBagViewModel
import com.example.mystybag.appCore.views.components.ClientWebHeaderBar
import com.example.mystybag.appCore.views.components.WebHeaderBottomDivider
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p8

/**
 * Web-only shell for add/edit bag (client header + bounded column + location-style accordion).
 */
@Composable
fun AddBagWebView(viewModel: AddBagViewModel) {
    UIView(
        viewModel = viewModel,
        modifier = Modifier.fillMaxSize(),
        showTopBar = false,
        removeVerticalPadding = true
    ) {
        Column(modifier = Modifier.fillMaxSize()) {
            ClientWebHeaderBar(
                selectedTab = 3,
                homeTabIndex = 0,
                deliveryTabIndex = 1,
                favoritesTabIndex = 2,
                menuTabIndex = 3,
                searchCallbacks = null,
                onFilterClick = {},
                showSearchAndFilter = false,
                showBackButton = true,
                onBackClick = { viewModel.navCallbacks.backButtonCallback() },
                centerTitle = sharedString(SR.strings.bag)
            )
            WebHeaderBottomDivider()
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f),
                contentAlignment = Alignment.TopCenter
            ) {
                AddBagScreenBody(
                    viewModel = viewModel,
                    columnModifier = Modifier
                        .width(1080.dp)
                        .fillMaxHeight()
                        .padding(horizontal = p16, vertical = p8),
                    isWebForm = true
                )
            }
        }
    }
}
